import { Card as MuiCard, CardProps } from '@mui/material'

export function Card(props: CardProps) {
  return <MuiCard {...props} />
}
